export default __webpack_public_path__ + "static/media/tts-for-everyone.2f31f779.mp3";